// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wordcloud[data-v-7a264fee]{margin-bottom:40px}.wordcloud .title[data-v-7a264fee]{width:100%;height:35px;font-size:18px;font-weight:700}.wordcloud .wordcloud[data-v-7a264fee]{width:100%;height:300px;margin-top:10px;border:1px solid #e6e6e6}", ""]);
// Exports
module.exports = exports;
